import * as marietta from '../../..';
import { Dialog } from '../../../core/view';

/**
 * 壁の高さ設定
 */
export default class WallHeightSettingDialog extends Dialog {
    targetFitting: marietta.webcad.item.Fitting;

    /**
     * コンストラクタ
     */
    constructor(draggable: boolean) {
      super(draggable);
      // ターゲットのアイテム
      this.targetFitting = marietta.webcad.WebCADGlobal.itemManager.currentItem as marietta.webcad.item.Fitting;

      // ダイアログのコンテンツ生成
      const id = 'wallHeightSettingDialog';
      let title = '高さ設定';

      // タイトル
      switch (marietta.webcad.WebCADGlobal.language) {
        case 'en': title = 'Height Setting'; break;
        default: title = '高さ設定'; break;
      }

      let contents = '<div class="dialogWallHeightSetting">\n';
      contents += '<table>\n';
      contents += '<tbody>\n';

      contents += '<table id="wallHeightSettingGroup">\n';
      contents += '<tbody>\n';

      contents += '<tr>\n';
      contents += '<th>\n<label for="wallHeight"><span class="jp">高さ</span><span class="en">Height</span></label></th>\n';
      contents += '<td>\n<input type="number" name="wallHeight" id="wallHeight">\n<td>mm</td>\n</td>\n';
      contents += '</tr>\n';
      contents += '</tbody>\n';
      contents += '</table>\n';

      contents += '</tbody>\n';
      contents += '</table>\n';
      contents += '</div>';

      let footer = '<button id="btnDoneWallHeightSetting"><span class="jp">ＯＫ</span><span class="en">OK</span></button>';
      footer += '<button id="btnCancelWallHeightSetting"><span class="jp">キャンセル</span><span class="en">Cancel</span></button>';

      this.createDialog(id, title, contents, footer);

      this.initMe();

      // イベント設定
      let btn = document.querySelector('#btnDoneWallHeightSetting');
      btn.addEventListener('click', this.updateHeight);

      // イベント設定
      document.querySelector('#btnCancelWallHeightSetting').addEventListener('click', this.close);


      // お掃除
      title = null;
      contents = null;
      footer = null;
      btn = null;
    }

    /**
     * ダイアログの初期設定
     */
    initMe() {
      const fittingHeight = (this.targetFitting as marietta.webcad.item.Fitting).itemInfo.fitting_height;
      if (fittingHeight !== null && fittingHeight !== undefined) {
        (<HTMLInputElement>document.getElementById('wallHeight')).value = ((this.targetFitting as marietta.webcad.item.Fitting).itemInfo.fitting_height).toString();
      }
    }

    /**
     * 壁の高さ設定
     */
    updateHeight = () => {
      // 入力チェック
      if ((<HTMLInputElement>document.getElementById('wallHeight')).value === '') {
        marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('WALLSETTING_NO_HEIGHT'), marietta.webcad.collection.WebCADMessages.getText('ERROR_TITLE'));
        return;
      }
      const height = parseFloat((<HTMLInputElement>document.getElementById('wallHeight')).value);
      if (Number.isNaN(height)) {
        marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('WALLSETTING_NO_HEIGHT'), marietta.webcad.collection.WebCADMessages.getText('ERROR_TITLE'));
        return;
      }
      //開口の場合は、高さがなければ、天井高さを代入する
      const ceilingHeight = marietta.webcad.view.dialog.RoomSetting.getBasicCeilingHeight( this.targetFitting.itemInfo.floor );
      if( this.targetFitting.itemInfo.id === 'fit02_01' && !( 0 <= height && height <= ceilingHeight ) ){
        marietta.webcad.WebCADGlobal.showAlert( `高さには、0以上${ceilingHeight}未満の数字を記入してください。` );
        return;
      }

      this.targetFitting.itemInfo.auto_height = false;
      this.targetFitting.itemInfo.fitting_height = height;

      //開口の場合は、上端高さも設定しておく
      if( this.targetFitting.itemInfo.id === 'fit02_01' ){
        this.targetFitting.itemInfo.z = this.targetFitting.itemInfo.fitting_height;
      }

      // 見積更新
      marietta.webcad.WebCADGlobal.quotationItemList.requestRebuild();

      // ダイアログを閉じる
      this.close();
    }
}
